import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {TranslateModule} from '@ngx-translate/core';
import {ContentModule} from '@shared/modules/content/content.module';
import {GroupsDialogComponent} from '@shared/dialog/groups-dialog/groups-dialog.component';
import {SecurityModule} from '@core/security/security.module';
import {IFrameModalComponent} from '@shared/dialog/i-frame/i-frame-modal.component';
import {DrillsterModalComponent} from '@shared/dialog/drillster/drillster-modal.component';
import {DrillsterComponent} from '@shared/dialog/drillster/drillster-iframe/drillster.component';
import {LightboxDialogComponent} from '@shared/dialog/lightbox-dialog/lightbox-dialog.component';
import {UserGroupsDialogComponent} from '@shared/dialog/user-groups-dialog/user-groups-dialog.component';

@NgModule({
    declarations: [
        UserGroupsDialogComponent,
        GroupsDialogComponent,
        IFrameModalComponent,
        DrillsterModalComponent,
        DrillsterComponent,
        LightboxDialogComponent,
    ],
    imports: [
        CommonModule,
        ContentModule,
        SharedModule,
        FlexModule,
        FlexLayoutModule,
        TranslateModule,
        SecurityModule,
    ],
})
export class DialogModule {
}
